<div class="sb-step sb-step-payment-method">

  <form class="sb-step__form" [formGroup]="formGroup">
    <!-- region Step container -->
    <section class="sb-step__form__content">
      <div class="sb-step__inner-container {{availablePaymentTypes.length > 2 ? 'sb-step__inner-container--big' : ''}}">


        <div class="wt-text-base-l wt-margin-bottom-4 error-note" *ngIf="translationKey || errorMessage">
          <sb-box-info [iconType]="['icon-alert-exlamation']"
                       [infoText]="(translationKey ? translationKey : errorMessage) | translate"></sb-box-info>
        </div>

        <div class="row sb-form-block" formGroupName="paymentMethod"
             [ngClass]="{'payment-small-container': availablePaymentTypes.length <= 3, 'col-tb-8': availablePaymentTypes.length <= 3}">
          <div class="col-xs-12 sb-form-block__title">
            {{'STEP.PAYMENT-METHOD.TITLE' | translate}}
          </div>
          <!-- region Payment methods -->
          <div class="row radio-container wt-margin-bottom-2">
            <ng-container *ngFor="let paymentType of availablePaymentTypes">
              <div class="col-xs-12 {{availablePaymentTypes.length <= 3 ? 'col-tb-12' : 'col-tb-6'}}">
                <wt-input-radio (click)="onChangePaymentMethodValue()" groupName="paymentMethod-radio-group" [value]="paymentType.id"
                                [disabled]="isPaymentMethodDisabled(paymentType.id)" formControlName="method" [isHTML]="true">
                  <sb-display-input-radio [invalid]="isPaymentMethodInvalid"
                                          [disabled]="isPaymentMethodDisabled(paymentType.id)"
                                          [lean]="true"
                                          [showRadioButton]="true"
                                          [checked]="formGroup.get('paymentMethod.method').value === paymentType.id"
                                          [title]="paymentType.title" [images]="paymentType.images"></sb-display-input-radio>
                </wt-input-radio>
              </div>
            </ng-container>
            <div class="payment-method-description-smart-top-up">
              <p>{{ getPaymentTranslationKey() | translate }}</p>
            </div>
          </div>
          <!-- endregion -->
        </div>
        <!--
        <div class="wt-text-base-l wt-margin-top-4 error-note">
          <sb-box-info [iconType]="['icon-alert-info-green']"
                       [infoText]="'Il pagamento tramite PayPal non è momentaneamente disponibile a causa di un aggiornamento dei sistemi.'"></sb-box-info>
        </div>
        -->

      </div>
    </section>
    <!-- endregion -->


    <!-- region Buttons -->
    <section class="sb-step__form__footer">
      <sb-navigation-buttons [isSticky]="shouldBeSticky" [submitDisabled]="this.formGroup.invalid" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"
                             [showPaypalContainer]="formGroup.get('paymentMethod.method').value === paymentMethodsEnum.PayPal"
                             [showUpperContainer]="formGroup.get('paymentMethod.method').value === paymentMethodsEnum.CreditCard"
                             [text]="inferPaymentButtonText(formGroup.get('paymentMethod.method').value)"
      >

        <sb-redirecting-sia-payment [paymentConfigurationUrl]="paymentSIAConfigurationUrl"
                                    [paymentSIAConfigurationData]="paymentSIAConfigurationData"
                                    [shouldBeSubmitted]="siaFormSubmitReady"
                                    (click)="submitSiaForm()"
                                    *ngIf="formGroup.get('paymentMethod.method').value === paymentMethodsEnum.CreditCard">
        </sb-redirecting-sia-payment>

      </sb-navigation-buttons>
    </section>
    <!-- endregion -->
  </form>
</div>
